/**
 * Date Utilities
 * Helper functions for date formatting in local timezone
 */

/**
 * Get today's date in local timezone (YYYY-MM-DD)
 * @returns {string} Date in YYYY-MM-DD format
 */
export function getTodayLocal() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

/**
 * Format a Date object to YYYY-MM-DD in local timezone
 * @param {Date} date - Date object to format
 * @returns {string} Date in YYYY-MM-DD format
 */
export function formatDateLocal(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
